import { useState, useCallback, useEffect } from 'react';
import api from '../utils/api';

export const useGet = (url, autoFetch = true) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(autoFetch);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(url);
      // If the response has a 'meta' key, it's a paginated response and we should keep it whole
      const finalData = (response.data.data !== undefined && response.data.meta !== undefined) 
        ? response.data 
        : (response.data.data !== undefined ? response.data.data : response.data);
      setData(finalData);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.message || 'Error occurred while fetching data');
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    if (autoFetch) fetchData();
  }, [fetchData, autoFetch]);

  return { data, loading, error, refresh: fetchData };
};

export const useMutation = (url, method = 'post') => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mutate = async (payload) => {
    setLoading(true);
    try {
      const response = await api[method.toLowerCase()](url, payload);
      setError(null);
      return { success: true, data: response.data };
    } catch (err) {
      const message = err.response?.data?.message || 'Error occurred';
      setError(message);
      return { success: false, error: message, validationErrors: err.response?.data?.errors };
    } finally {
      setLoading(false);
    }
  };

  return { mutate, loading, error };
};
